"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAdContext = void 0;
function buildAdContext({ searchMethod, productFit, adId, category, placement, impressionPosition, groupId, creativeId, creativeTitle, advertiserName, campaignName, productName, }) {
    const data = {
        search_method: searchMethod,
        product_fit: productFit,
        ad_id: adId,
        category: category?.toLocaleLowerCase(),
        placement,
        impression_position: impressionPosition,
        group_id: groupId?.toString(),
        creative_id: creativeId?.toString(),
        creative_title: creativeTitle,
        advertiser_name: advertiserName,
        campaign_name: campaignName,
        product_name: productName,
    };
    return {
        schema: 'iglu:com.healthcare/ad/jsonschema/1-0-5',
        data,
    };
}
exports.buildAdContext = buildAdContext;
//# sourceMappingURL=build-ad-context.js.map